// La imagen Docker es la misma en QA y en producción. Al arrancar, nginx
// escribe window.__EKI_CONFIG__. Si una clave no viene ahí, queda el valor
// que Vue CLI dejó en el build.
const built = {
  VUE_APP_TITLE: process.env.VUE_APP_TITLE,
  VUE_APP_URL: process.env.VUE_APP_URL,
  VUE_APP_API_URL: process.env.VUE_APP_API_URL,
  VUE_APP_PLAYER_URL: process.env.VUE_APP_PLAYER_URL,
  VUE_APP_CRIPTO_KEY: process.env.VUE_APP_CRIPTO_KEY,
  VUE_APP_BROOM_SOCKET_ENDPOINT: process.env.VUE_APP_BROOM_SOCKET_ENDPOINT,
  VUE_APP_FCM_SERVER_KEY: process.env.VUE_APP_FCM_SERVER_KEY,
};

export function runtimeEnv(name) {
  const runtime = typeof window !== "undefined" ? window.__EKI_CONFIG__ : null;
  const value = runtime && runtime[name];
  if (value != null && value !== "") {
    return value;
  }
  return built[name];
}
